/* assets/pz-vendita.js · Pozzalume, V1-VENDITA
   Le leve di vendita del tema: tutto funziona anche senza questo file (moduli veri, link veri), qui c'e' solo l'aiuto.
     - finestre di data: [data-pz-dal] e [data-pz-al] (4 cifre MMGG = ogni anno, 8 cifre AAAAMMGG = una volta sola)
       mostrano o nascondono un elemento secondo la data di chi guarda (le pagine di Shopify restano in cache);
       data-pz-prova="x" piu' ?prova-x nell'indirizzo lo mostra per le prove. Si rifa' a ogni pz:carrello;
     - moduli cliente [data-pz-lead]: dopo l'invio Shopify torna con ?customer_posted=true e ogni modulo si crede
       inviato; resta la conferma solo su quello inviato davvero (sessionStorage), e l'iscrizione si ricorda
       (localStorage pz-iscritto) cosi' il biglietto all'uscita non compare piu';
     - regalo [data-pz-regalo]: i campi si salvano subito negli attributi del carrello (/cart/update.js) e nel telefono
       (localStorage pz-regalo) per il biglietto da stampare;
     - biglietto all'uscita [data-pz-uscita]: al telefono una risalita veloce dopo meta' pagina, al computer il mouse che
       esce dall'alto; una volta per visita, mai a chi e' iscritto, mai col banner dei cookie o col cassetto aperti;
     - benvenuti: ?ed=base|completo mostra [data-pz-ed-solo]; porta una famiglia: copia e condividi il link;
     - link personale di porta una famiglia (BLOOP, r-bloop.cc): arriva con ?bsid=; senza il widget di BLOOP lo sconto
       dell'invitato lo applica questo file (/discount/ prefisso + bsid, prefisso da body[data-pz-invito]), una volta per visita;
     - biglietto del regalo: il foglio segue i campi, e il bottone stampa;
     - le finestrelle dell'Avvento si aprono e gli eroi della prima sera si alzano quando entrano in vista.
   Nessun testo scritto qui: le frasi arrivano dagli attributi data-* (file di lingua). Movimento solo transform e
   opacity (in pz-vendita.css), niente con prefers-reduced-motion. Caricato con defer. */
(function () {
  'use strict';
  var d = document, w = window, html = d.documentElement;
  var ridotto = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var cerca = w.location.search || '';
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function leggi(a, k) { try { return w[a].getItem(k); } catch (e) { return null; } }
  function scrivi(a, k, v) { try { w[a].setItem(k, v); } catch (e) { /* senza memoria si va avanti lo stesso */ } }
  function prova(nome) { return !!nome && new RegExp('[?&]prova-' + nome + '\\b').test(cerca); }
  if (!ridotto) html.classList.add('pz-vendita-viva');

  /* ---------------------------------------------------- finestre di data -- */
  function oggi() {
    var t = new Date();
    return { anno: t.getFullYear() * 10000 + (t.getMonth() + 1) * 100 + t.getDate(), giorno: (t.getMonth() + 1) * 100 + t.getDate() };
  }
  function dentro(el, o) {
    if (prova(el.getAttribute('data-pz-prova'))) return true;
    var dal = el.getAttribute('data-pz-dal') || '', al = el.getAttribute('data-pz-al') || '';
    function n(v) { return v.length === 4 ? o.giorno : o.anno; }
    if (dal && n(dal) < Number(dal)) return false;
    if (al && n(al) > Number(al)) return false;
    return true;
  }
  function finestre() {
    var o = oggi();
    $$('[data-pz-dal], [data-pz-al]').forEach(function (el) { el.hidden = !dentro(el, o); });
    $$('[data-pz-doni]').forEach(function (s) {
      var avv = $('[data-pz-prova="avvento"]', s);
      s.setAttribute('data-avvento', avv && !avv.hidden ? '1' : '0');
    });
  }
  finestre();
  d.addEventListener('pz:carrello', function () { setTimeout(finestre, 0); });

  /* ------------------------------------------------------ moduli cliente -- */
  var CHIAVE_LEAD = 'pz-lead-inviato';
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-pz-lead]')) return;
    scrivi('sessionStorage', CHIAVE_LEAD, f.id || '');
  }, true);
  var inviato = leggi('sessionStorage', CHIAVE_LEAD);
  var postato = /[?&]customer_posted=true\b/.test(cerca);
  $$('form[data-pz-lead]').forEach(function (f) {
    var fatto = $('[data-pz-lead-fatto]', f), campi = $('[data-pz-lead-campi]', f), errore = $('[data-pz-lead-errore]', f);
    var mio = inviato && f.id === inviato;
    if (fatto && !mio) { fatto.parentNode.removeChild(fatto); if (campi) campi.hidden = false; }
    if (errore && inviato && !mio) errore.parentNode.removeChild(errore);
    if (fatto && mio && postato) {
      scrivi('localStorage', 'pz-iscritto', '1');
      var uscita = f.closest('[data-pz-uscita]');
      if (uscita) { mostraUscita(uscita, true); }
      setTimeout(function () { try { fatto.focus({ preventScroll: false }); } catch (x) { fatto.focus(); } }, 60);
    }
    if (errore && mio) {
      var uscita2 = f.closest('[data-pz-uscita]');
      if (uscita2) mostraUscita(uscita2, true);
      var em = $('input[type="email"]', f); if (em) setTimeout(function () { em.focus(); }, 60);
    }
  });
  if (postato && inviato) scrivi('sessionStorage', CHIAVE_LEAD, '');

  /* --------------------------------------------------------------- regalo -- */
  var timerRegalo = 0, inAttesa = {};
  function memoriaRegalo() { try { return JSON.parse(leggi('localStorage', 'pz-regalo') || '{}') || {}; } catch (e) { return {}; } }
  function salvaRegalo(box) {
    var attr = {}, casella = $('.pz-regalo__casella', box), si = casella && casella.checked;
    $$('[data-pz-attr]', box).forEach(function (c) {
      var k = c.getAttribute('data-pz-attr');
      attr[k] = si ? c.value : '';
    });
    // gli altri riquadri del regalo (cassetto e pagina del carrello) restano uguali
    $$('[data-pz-regalo]').forEach(function (altro) {
      if (altro === box) return;
      $$('[data-pz-attr]', altro).forEach(function (c) {
        var k = c.getAttribute('data-pz-attr');
        if (c.type === 'checkbox') c.checked = !!si; else if (k in attr && si) c.value = attr[k];
      });
    });
    var nomi = $$('[data-pz-attr]', box).filter(function (c) { return c.type !== 'checkbox'; });
    var m = memoriaRegalo();
    if (si) { m.nome = nomi[0] ? nomi[0].value : ''; m.messaggio = nomi[1] ? nomi[1].value : ''; scrivi('localStorage', 'pz-regalo', JSON.stringify(m)); }
    for (var k in attr) inAttesa[k] = attr[k];
    clearTimeout(timerRegalo);
    timerRegalo = setTimeout(function () {
      var corpo = { attributes: inAttesa }; inAttesa = {};
      fetch((w.Shopify && w.Shopify.routes && w.Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo)
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        var stato = $('[data-pz-regalo-stato]', box), link = $('[data-pz-regalo-salvato]', box);
        if (stato && link && si) stato.textContent = link.getAttribute('data-pz-regalo-salvato');
      }).catch(function () { /* il modulo li manda comunque al checkout */ });
    }, 600);
  }
  ['input', 'change'].forEach(function (tipo) {
    d.addEventListener(tipo, function (e) {
      var c = e.target;
      if (!c || !c.closest) return;
      var box = c.closest('[data-pz-regalo]');
      if (box && c.hasAttribute('data-pz-attr')) salvaRegalo(box);
    });
  });

  /* -------------------------------------------------- biglietto all'uscita -- */
  function bannerCookieAperto() { var b = d.getElementById('base-consent'); return !!(b && !b.hidden); }
  function cassettoAperto() { var c = d.getElementById('pz-cassetto'); return !!(c && (c.open || c.hasAttribute('open'))); }
  function sotto(uscita) {
    var h = 0;
    $$('[data-barra], [data-barra-scheda]').forEach(function (b) {
      if (b.hidden) return;
      var r = b.getBoundingClientRect(), s = w.getComputedStyle(b);
      if (s.display !== 'none' && s.visibility !== 'hidden' && r.height > 0 && r.top < w.innerHeight && r.bottom > w.innerHeight - 4) h = Math.max(h, Math.round(w.innerHeight - r.top));
    });
    uscita.style.setProperty('--pz-sotto', h + 'px');
  }
  function mostraUscita(uscita, conModulo) {
    sotto(uscita);
    uscita.hidden = false;
    scrivi('sessionStorage', 'pz-uscita-vista', '1');
    if (conModulo) apriModulo(uscita, false);
    if (!ridotto) { uscita.classList.add('is-fuori'); w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { uscita.classList.remove('is-fuori'); }); }); }
  }
  function apriModulo(uscita, fuoco) {
    var m = $('[data-pz-uscita-modulo]', uscita), b = $('[data-pz-uscita-apri]', uscita);
    if (m) m.hidden = false;
    if (b) { b.setAttribute('aria-expanded', 'true'); b.hidden = true; }
    if (fuoco) { var em = $('input[type="email"]', uscita); if (em) em.focus(); }
  }
  function chiudiUscita(uscita) {
    if (ridotto) { uscita.hidden = true; return; }
    uscita.classList.add('is-fuori');
    setTimeout(function () { uscita.hidden = true; uscita.classList.remove('is-fuori'); }, 420);
  }
  var uscita = $('[data-pz-uscita]');
  if (uscita) {
    var chiudi = $('[data-pz-uscita-chiudi]', uscita), apri = $('[data-pz-uscita-apri]', uscita);
    if (chiudi) chiudi.addEventListener('click', function () { chiudiUscita(uscita); });
    if (apri) apri.addEventListener('click', function () { apriModulo(uscita, true); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !uscita.hidden) chiudiUscita(uscita); });
    var gia = leggi('sessionStorage', 'pz-uscita-vista') || leggi('localStorage', 'pz-iscritto');
    var arrivo = Date.now();
    var puo = function () { return uscita.hidden && !leggi('sessionStorage', 'pz-uscita-vista') && !leggi('localStorage', 'pz-iscritto') && !bannerCookieAperto() && !cassettoAperto() && Date.now() - arrivo > 6000 && w.scrollY > w.innerHeight; };
    if (prova('uscita')) { setTimeout(function () { mostraUscita(uscita, false); }, 300); }
    else if (!gia) {
      var tocco = w.matchMedia && w.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (tocco) {
        var maxY = 0, ultimaY = w.scrollY, ultimaT = Date.now(), salita = 0;
        w.addEventListener('scroll', function () {
          var y = w.scrollY, t = Date.now(), alto = d.documentElement.scrollHeight - w.innerHeight;
          if (y > maxY) maxY = y;
          if (y < ultimaY) { salita += ultimaY - y; } else { salita = 0; }
          if (t - ultimaT > 400) salita = Math.max(0, ultimaY - y);
          // risalita veloce: almeno 220 px verso l'alto in poco tempo, dopo aver passato meta' pagina
          if (alto > 0 && maxY > alto * 0.5 && salita > 220 && t - ultimaT < 400 && puo()) mostraUscita(uscita, false);
          ultimaY = y; ultimaT = t;
        }, { passive: true });
      } else {
        d.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0 && puo()) mostraUscita(uscita, false);
        });
      }
    }
  }

  /* ----------------------------------------------------------- benvenuti -- */
  var ed = (cerca.match(/[?&]ed=(base|completo)\b/) || [])[1];
  if (ed) {
    $$('[data-pz-ed-solo="' + ed + '"]').forEach(function (el) { el.hidden = false; });
    $$('[data-pz-ed-no="' + ed + '"], [data-pz-ed-senza]').forEach(function (el) { el.hidden = true; });
  }

  var fam = $('[data-pz-famiglia]');
  if (fam) {
    var campo = $('[data-pz-famiglia-link]', fam), copia = $('[data-pz-famiglia-copia]', fam), cond = $('[data-pz-famiglia-condividi]', fam), stato = $('[data-pz-famiglia-stato]', fam);
    if (copia && campo && navigator.clipboard && w.isSecureContext) {
      copia.hidden = false;
      copia.addEventListener('click', function () {
        navigator.clipboard.writeText(campo.value).then(function () { if (stato) stato.textContent = fam.getAttribute('data-pz-copiato'); }, function () { campo.select(); });
      });
    }
    if (cond && campo && navigator.share) {
      cond.hidden = false;
      cond.addEventListener('click', function () {
        navigator.share({ text: fam.getAttribute('data-pz-condividi-testo'), url: campo.value }).catch(function () {});
      });
    }
    if (campo) campo.addEventListener('focus', function () { campo.select(); });
  }

  /* ------------------------------------------- link personale (BLOOP) -- */
  var bsid = (cerca.match(/[?&]bsid=([A-Za-z0-9]{4,24})(?:&|$)/) || [])[1], pref = d.body && d.body.getAttribute('data-pz-invito');
  if (bsid && pref && w.fetch && leggi('sessionStorage', 'pz-bsid') !== bsid) {
    w.fetch('/discount/' + encodeURIComponent(pref + bsid) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function (r) { if (r.ok) scrivi('sessionStorage', 'pz-bsid', bsid); }, function () { /* resta il codice da scrivere al checkout */ });
  }

  /* ------------------------------------------------- biglietto del regalo -- */
  var big = $('[data-pz-biglietto]');
  if (big) {
    var m = memoriaRegalo();
    $$('[data-pz-b-campo]', big).forEach(function (c) {
      var k = c.getAttribute('data-pz-b-campo'), uscitaEl = $('[data-pz-b="' + k + '"]', big);
      if (!c.value && m[k]) c.value = m[k];
      function aggiorna() {
        if (!uscitaEl) return;
        var v = c.value.trim();
        uscitaEl.textContent = v || uscitaEl.getAttribute('data-vuoto');
        uscitaEl.classList.toggle('is-vuoto', !v);
      }
      aggiorna();
      c.addEventListener('input', function () {
        aggiorna();
        var mm = memoriaRegalo(); mm[k] = c.value; scrivi('localStorage', 'pz-regalo', JSON.stringify(mm));
      });
    });
    var stampa = $('[data-pz-stampa]', big);
    if (stampa && w.print) { stampa.hidden = false; stampa.addEventListener('click', function () { w.print(); }); }
  }

  /* ------------------------------------- stanza aperta della Bottega -- */
  /* L'assaggio entra solo al tocco: la finestra e l'iframe nascono qui, i suoni li fa partire il tocco dentro. */
  var finestra = null;
  function chiudiStanza() { if (finestra && finestra.open) finestra.close(); }
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pz-stanza]');
    if (!a || typeof HTMLDialogElement !== 'function') return;
    e.preventDefault();
    if (!finestra) {
      finestra = d.createElement('dialog');
      finestra.className = 'pz-stanza__finestra';
      finestra.setAttribute('aria-label', a.getAttribute('data-pz-stanza-titolo'));
      var chiudi = d.createElement('button');
      chiudi.type = 'button'; chiudi.className = 'pz-stanza__chiudi';
      chiudi.textContent = a.getAttribute('data-pz-stanza-chiudi');
      chiudi.addEventListener('click', chiudiStanza);
      var fr = d.createElement('iframe');
      fr.className = 'pz-stanza__cornice';
      fr.title = a.getAttribute('data-pz-stanza-titolo');
      fr.setAttribute('allow', 'autoplay');
      finestra.appendChild(chiudi); finestra.appendChild(fr);
      finestra.addEventListener('click', function (ev) { if (ev.target === finestra) chiudiStanza(); });
      /* chiusa la finestra si ricarica l'assaggio: la musica si ferma */
      finestra.addEventListener('close', function () { fr.src = 'about:blank'; finestra.removeAttribute('data-caricata'); });
      d.body.appendChild(finestra);
    }
    var cornice = $('.pz-stanza__cornice', finestra);
    if (!finestra.hasAttribute('data-caricata')) { cornice.src = a.href; finestra.setAttribute('data-caricata', ''); }
    finestra.showModal();
  });

  /* ------------------------------------------------ movimento in vista -- */
  if (!ridotto && 'IntersectionObserver' in w) {
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) { v.target.classList.add('is-vivo'); io.unobserve(v.target); }
      });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0.2 });
    $$('.pz-dono, .pz-avvento, .benvenuti__palco, .dietro__foto').forEach(function (el) { io.observe(el); });
  } else {
    $$('.pz-dono, .pz-avvento, .benvenuti__palco, .dietro__foto').forEach(function (el) { el.classList.add('is-vivo'); });
  }
})();
